import { css, type Theme } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";
import * as helpers from "@styles/emotion-styles/helpers";

export const magicLinkButton = (theme: Theme) => css`
  width: 250px;
  padding: 0.5625rem 0.3125rem 0.5625rem 0.5625rem;
  border-radius: ${dimensions.borderRadius};
  border: 1px solid ${theme.system.borderBase};
  background-color: ${theme.text.onBackground};
  color: ${theme.surface.overlayDark};
  text-align: center;
  &:hover {
    box-shadow: 0 1px 2px 0 ${helpers.hexToRgba(theme.text.body, 0.25)};
    border: 1px solid ${theme.system.borderHover};
    background-color: ${theme.system.backgroundBase};
    color: ${theme.system.textLabelEmphasis};
  }
`;

export const buttonWrapper = css`
  text-align: center;
  width: 100%;
  align-content: center;
`;
